import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibDeleteFillIcon } from '@chewy/kib-icons-react'
import classNames from 'classnames'

import {
  CalculatorIcon,
  DeclineIcon,
} from '~/components/elements/Icons/generated'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import styles from './ChargesActions.module.scss'

export interface ChargesActionsProps {
  className?: string
  declineHighlighted?: boolean
  disabled?: boolean
  disabledCalculator?: boolean
  disabledDecline?: boolean
  disabledDelete?: boolean
  onCalculatorClick?: () => void
  onDeclineClick?: () => void
  onDeleteClick?: () => void
  showCalculatorButton?: boolean
  showDeclineButton?: boolean
  showDeleteButton?: boolean
}

const ChargesActions = ({
  className,
  declineHighlighted = false,
  disabled = false,
  disabledCalculator,
  disabledDecline,
  disabledDelete,
  onCalculatorClick,
  onDeclineClick,
  onDeleteClick,
  showCalculatorButton = true,
  showDeclineButton = true,
  showDeleteButton = true,
}: ChargesActionsProps) => {
  const { t } = useTranslation()

  return (
    <div className={classNames(styles.actionsCell, className)}>
      <div className={styles.buttonContainer}>
        {showDeleteButton && (
          <KibButtonNew
            iconOnly
            aria-label={t('Common:DELETE_ACTION')}
            className={styles.actionButton}
            disabled={disabledDelete ?? disabled}
            icon={<KibDeleteFillIcon />}
            size="medium"
            onClick={onDeleteClick}
          />
        )}
        {showDeclineButton && (
          <KibButtonNew
            iconOnly
            aria-label={t('Common:DECLINE_ACTION')}
            className={classNames(styles.actionButton, {
              [styles.declineHighlighted]: declineHighlighted,
            })}
            disabled={disabledDecline ?? disabled}
            icon={<DeclineIcon />}
            size="medium"
            onClick={onDeclineClick}
          />
        )}
        {showCalculatorButton && (
          <KibButtonNew
            iconOnly
            aria-label={t('Common:CALCULATOR')}
            className={styles.actionButton}
            disabled={disabledCalculator ?? disabled}
            icon={<CalculatorIcon />}
            size="medium"
            onClick={onCalculatorClick}
          />
        )}
      </div>
    </div>
  )
}

export default ChargesActions
